import { createApp } from 'vue'
import App from './App.vue'
import { i18n, installLocalePersistence, loadLocale } from './i18n'
import './style.css'

// Promote the non-blocking font preload to a real stylesheet. Doing it here
// rather than with an inline `onload` attribute keeps the production CSP free
// of 'unsafe-hashes'.
document.getElementById('font-css')?.setAttribute('rel', 'stylesheet')

const app = createApp(App)
app.use(i18n)
installLocalePersistence()

// A returning reader whose saved locale is not the bundled one needs its
// messages before first paint, or English would flash first. `loadLocale`
// resolves immediately when the active locale is already resident, so the
// common path costs nothing. No top-level await — that would force a newer
// build target than the browsers this page supports.
loadLocale(i18n.global.locale.value).finally(() => app.mount('#app'))
